import * as React from "react";
import { steppers, ButtonLabels } from "../../Resource/Contents";
import { ClientDetail } from "./ClientDetail";
import { ContactDetail } from "./ContactDetail";
import { IAddClientModel, Journey } from "../AddClientWizard";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { CustomerMatching } from "../CustomerMatching/CustomertMatching";
import { CustomerMatchingAction } from "../../Actions/CustomerMatchingAction";
import { CustomerSearchModel } from "../../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { validationMessage } from "../../Resource/Validation";
import { UserStore } from "../../../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import AdviserSiteTagManager from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { getAgefromDateOfBirth } from "../../../../../../Shared/Utils/getAgefromDateOfBirth";

interface IClientDetailsProps extends IProcessComponentProps {
    data: IAddClientModel;
    onSubmit: (journeyType: Journey) => void;
}

interface IClientDetailsState {
    isOpen: boolean;
    isCustomerMatchingOpen: boolean;
    customerMatchingResult: CustomerSearchModel;
    journeyType: Journey;
}

export class ClientDetails extends ProcessComponent<IClientDetailsProps, IClientDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = { isOpen: false, isCustomerMatchingOpen: false, customerMatchingResult: null, journeyType: null };
    }

    private naviagetToPreviousPage() {
        Navigator.navigateToAndPreserveQueryParameters(Urls.get().ClientType);
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        super.componentDidMount();
        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname,
                pageTitle: `${document.title} - add new client - cliet details`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }

    private getCustomerMatchingData(pageIndex, pageSize) {
        const { data } = this.props;
        CustomerMatchingAction.getMatchingCustomers(
            data.Prospect.FirstName,
            data.Prospect.Surname,
            data.Prospect.DateOfBirth,
            data.Prospect.OwnerAdviserId,
            pageIndex,
            pageSize,
            (result: CustomerSearchModel) => {
                if (result.CustomerList && result.CustomerList?.length > 0) {
                    this.setState({ isCustomerMatchingOpen: true, customerMatchingResult: result });
                } else {
                    this.props.onSubmit(this.state.journeyType);
                }
            }
        );
    }

    isValid() {
        const data: IAddClientModel = this.props.data;
        let flag = super.isValid();
        if (!data?.Prospect?.FirstName) {
            this.props.showErrorMsgPopUp([validationMessage.firstNameValidation], true);
            flag = false;
        }
        if (!data?.Prospect?.Surname) {
            this.props.showErrorMsgPopUp([validationMessage.surnameValidation], true);
            flag = false;
        }
        if (!data?.Prospect?.DateOfBirth) {
            this.props.showErrorMsgPopUp([validationMessage.dateOfBirthValidation], true);
            flag = false;
        }
        if (data?.Prospect?.DateOfBirth && getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(data?.Prospect?.DateOfBirth)) < 18) {
            this.props.showErrorMsgPopUp([validationMessage.dateOfBirthJuniorValidation], true);
            flag = false;
        }
        return flag;
    }

    private submitClient(journeyType: Journey) {
        if (this.isValid()) {
            this.setState({ journeyType: journeyType });
            this.getCustomerMatchingData(1, 10);
        }
    }

    private onPageChange(pageIndex, pageSize) {
        this.getCustomerMatchingData(pageIndex, pageSize);
    }

    private onDismissCustomerMatchings() {
        this.props.onSubmit(this.state.journeyType);
    }

    render() {
        const { data, onChange } = this.props;
        return (
            <>
                <h2>{steppers.clientDetails}</h2>
                {data.CustomerType === CustomerType.Individual && (
                    <>
                        <ClientDetail
                            data={data && data.Prospect ? data.Prospect : {}}
                            onChange={(changes) => {
                                this.onDataChange(onChange, changes, data, "Prospect");
                                if (changes?.DateOfBirth && getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(changes?.DateOfBirth)) < 18) {
                                    this.props.showErrorMsgPopUp([validationMessage.dateOfBirthJuniorValidation], true);
                                }
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                        <ContactDetail
                            data={data && data.Prospect ? data.Prospect : {}}
                            onChange={(changes) => {
                                this.onDataChange(onChange, changes, data, "Prospect");
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                    </>
                )}

                <div className="page-actions">
                    <div className="action-secondary">
                        <button
                            onClick={() => {
                                this.naviagetToPreviousPage();
                            }}
                            className="prev-button"
                        >
                            <span aria-hidden="true" className="icon"></span>
                            <span className="text">{ButtonLabels.previousLabel}</span>
                        </button>
                    </div>
                    <div className="action-primary">
                        <div className="primary-dropdown">
                            <button
                                className="trigger"
                                aria-expanded={this.state.isOpen}
                                aria-haspopup="true"
                                onClick={() =>
                                    this.updateStatePart((x) => {
                                        x.isOpen = !this.state.isOpen;
                                    })
                                }
                            >
                                <span className="text">{ButtonLabels.nextLabel}</span>
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                            {this.state.isOpen && (
                                <div className="dropdown-list a-dropdown-enter-done">
                                    <div className="dropdown-list-panel">
                                        <button className="item" onClick={() => this.submitClient(Journey.AddClient)}>
                                            {ButtonLabels.addClient}
                                        </button>
                                        <button className="item" onClick={() => this.submitClient(Journey.Quote)}>
                                            {ButtonLabels.quote}
                                        </button>
                                        <button className="item" onClick={() => this.submitClient(Journey.NewBusiness)}>
                                            {ButtonLabels.newBusiness}
                                        </button>
                                        <button
                                            className="item"
                                            onClick={() => this.submitClient(Journey.CreateAnotherClient)}
                                        >
                                            {ButtonLabels.createAnotherClient}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {this.state.isCustomerMatchingOpen && (
                                <Lightbox
                                    show={this.state.isCustomerMatchingOpen}
                                    title={"Client matches"}
                                    contentAfterTitle={null}
                                    onClose={() => this.setState({ isCustomerMatchingOpen: false })}
                                    type={LightboxType.Modal}
                                    unclosable={true}
                                    noOverlay={false}
                                    noAutofocus={true}
                                    cssWrapper="is-default-lightbox"
                                >
                                    <CustomerMatching
                                        data={this.state.customerMatchingResult}
                                        onPageChange={(pageIndex, pageSize) => this.onPageChange(pageIndex, pageSize)}
                                        onDismissMatches={() => this.onDismissCustomerMatchings()}
                                        displayChooseClientOption={false}
                                    ></CustomerMatching>
                                </Lightbox>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
